import type { ReactNode } from 'react';

import { PortalClientProvider } from '@ngsos/portal-core/portal';

import { getAccessToken } from '@/api/auth';
import { useTopology } from '@/app/topology';

export function IncidentDataProvider({ children }: { children: ReactNode }) {
  const topology = useTopology();

  return (
    <PortalClientProvider
      emsServerUrl={topology.emsServerUrl}
      accessTokenFactory={async () => (await getAccessToken()) ?? ''}
      onError={(message, error) => console.error(message, error)}
    >
      {children}
    </PortalClientProvider>
  );
}
